(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.toggle('hidden', !errorMessage);
      errorWrapper.textContent = errorMessage || '';
    }

    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (disable) {
          submitButton?.setAttribute('disabled', 'disabled');
          if (text && submitButton) submitButton.textContent = text;
        } else if (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
        }
      });
    }
  }
  const countryCurrencyMap = {
          AT: "EUR", BE: "EUR", BG: "BGN", HR: "EUR", CY: "EUR", CZ: "CZK", DK: "DKK", EE: "EUR", FI: "EUR", FR: "EUR", DE: "EUR", GR: "EUR", HU: "HUF",IE: "EUR", IT: "EUR", LV: "EUR", LT: "EUR", LU: "EUR", MT: "EUR", NL: "EUR", PL: "PLN", PT: "EUR", RO: "RON", SK: "EUR", SI: "EUR", ES: "EUR", SE: "SEK", GB: "GBP" };

  function formatMoney3(cents) {
      const select = document.querySelector("#country-drawer-selector-header");
      const country = select.value; 
      const currency = countryCurrencyMap[country];
      let locale = "en-IE";
      if (currency === "HUF") locale = "hu-HU";
      if (currency === "BGN") locale = "bg-BG";
      if (currency === "CZK") locale = "cs-CZ";
      if (currency === "DKK") locale = "da-DK";
      if (currency === "PLN") locale = "pl-PL";
      if (currency === "RON") locale = "ro-RO";
      if (currency === "SEK") locale = "sv-SE";
      if (currency === "GBP") locale = "en-GB";
      return (cents / 100).toLocaleString(locale, {
          style: "currency",
          currency: currency,
      });
  }
    function getRelatedProducts3() {
        const container = document.querySelector("#related-cart-products");
        if (!container) return;
        const productShowLimit = document.querySelector("#related-cart-products").getAttribute('productShowLimit');
        const productId = container.getAttribute("data-product-id");
        fetch(`/recommendations/products.json?product_id=${productId}&limit=4`)
        .then(response => response.json())
        .then(data => {
            if (!data.products.length) return;
            const translation = container.getAttribute("data-translation");
            let html = `
                <h3 class="related-title">${translation}</h3>
                <div class="related-grid">
            `;
            data.products.forEach(product => {
                html += `
                    <div class="related-item">
                        <a href="${product.url}">
                            <img src="${product.featured_image}" alt="${product.title}" />
                            <div class="related_info">
                                <p class="card_title">${product.title}</p>
                                <p class="card_price">${formatMoney3(product.price)}</p>
                            </div>
                        </a>
                        <button class="related-add-btn" data-variant-id="${product.variants[0].id}">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(255,255,255,1)"><path d="M13.0001 10.9999L22.0002 10.9997L22.0002 12.9997L13.0001 12.9999L13.0001 21.9998L11.0001 21.9998L11.0001 12.9999L2.00004 13.0001L2 11.0001L11.0001 10.9999L11 2.00025L13 2.00024L13.0001 10.9999Z"></path></svg>
                        </button>
                    </div>
                `;
            });
            html += `</div>`;
            container.innerHTML = html;
            var ItemLength = document.querySelectorAll('cart-drawer-items .cart-drawer__items .cart-item')?.length;
        })
        .then(res =>{
            document.addEventListener("click", function(e) {
                const btn = e.target.closest(".related-add-btn");
                if (!btn) return;
                if (btn.disabled) return; // stop double-clicks
                btn.disabled = true;
                const variantId = btn.getAttribute("data-variant-id");
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                })
                .then(res => res.json())
                .then(() => {
                    fetch("/cart?view=drawer-items")
                        .then(r => r.text())
                        .then(html => {
                            // Parse HTML string into DOM
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, "text/html");
                            const newItems = doc.querySelector(".cart-drawer__items");
                            const currentItems = document.querySelector(".cart-drawer__items");
                            if (newItems && currentItems) {
                                currentItems.innerHTML = newItems.innerHTML;
                            }
                            // Update recommended based on *new* last item
                            return fetch("/cart.js");
                        })
                        .then(r => r.json())
                        .then(cart => {
                            if (cart.items.length > 0) {
                                const last = cart.items[cart.items.length - 1];
                                document.querySelector("#related-cart-products").setAttribute("data-product-id", last.product_id);
                            }
                            getRelatedProducts3();
                        });
                })
                .catch(err => console.error("Add to cart error:", err));
            });
        });
    }
  customElements.define('product-form', ProductForm);
})();
